import { createBrowserRouter } from 'react-router-dom';
import Landing from '../pages/Landing';
import ModalDetail from '@/pages/PostDetail';
import Navbar from '@/components/Navbar';
import Profile from '@/pages/Profile';
import MyModels from '@/pages/MyModels';
import PrivateRoute from '@/components/PrivateRoute';
import PreviewModalDetail from '@/pages/Preview';
import PostUpload from '@/pages/PostUpload';
import Footer from '@/components/Footer';
import Signup from '@/pages/Signup';
import RouteWrapper from '@/components/RouteWrapper';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import NotFound from '@/pages/NotFound';
import ResetPassword from '@/pages/ResetPassword';
import ChangePassword from '@/pages/ChangePassword';
import ErrorBoundary from '@/pages/ErrorBoundary';

const routerRoutes = createBrowserRouter([
  {
    path: '/',
    element: (
      <RouteWrapper>
        <Navbar />
        <Landing />
        <Footer />
      </RouteWrapper>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/model/:id',
    element: (
      <RouteWrapper>
        <Navbar />
        <ModalDetail />
        <Footer />
      </RouteWrapper>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/model/preview/',
    element: (
      <RouteWrapper>
        <Navbar />
        <PreviewModalDetail />
        <Footer />
      </RouteWrapper>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/myprojects',
    element: (
      <RouteWrapper>
        <PrivateRoute>
          <Navbar />
          <MyModels />
        </PrivateRoute>
        <Footer />
      </RouteWrapper>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/:username',
    element: (
      <RouteWrapper>
        <PrivateRoute>
          <Navbar />
          <Profile />
        </PrivateRoute>
        <Footer />
      </RouteWrapper>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/project/create',
    element: (
      <RouteWrapper>
        <PrivateRoute>
          <PostUpload />
          <Footer />
        </PrivateRoute>
      </RouteWrapper>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/project/edit/:postId',
    element: (
      <RouteWrapper>
        <PrivateRoute>
          <PostUpload />
          <Footer />
        </PrivateRoute>
      </RouteWrapper>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/changePassword',
    element: (
      <RouteWrapper>
        <PrivateRoute>
          <Navbar />
          <ChangePassword />
          <Footer />
        </PrivateRoute>
      </RouteWrapper>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/signup',
    element: <Signup />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/resetPassword',
    element: (
      <>
        <Navbar />
        <ResetPassword />
        <Footer />
      </>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/privacyPolicy',
    element: (
      <>
        <Navbar />
        <PrivacyPolicy />
        <Footer />
      </>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '*',
    element: <NotFound />,
    errorElement: <ErrorBoundary />,
  },
]);

export default routerRoutes;
